module.exports = __webpack_public_path__ + "img/kitten.b2c31e26.jpg";